<template>
  <b-modal
    v-model="show"
    size="xl"
    hide-footer
    hide-header
    body-class="p-0"
    modal-class="compare-rules-modal"
    content-class="h-100"
    dialog-class="h-100 m-0"
  >
    <div class="d-flex flex-column h-100">
      <div class="bg-gray-100 border-bottom p-3 d-flex justify-content-between align-items-center">
        <h5 class="font-weight-bold mb-0 text-gray-700">Comparar Regras</h5>
        <button class="btn btn-link p-0" @click="close">
          <i class="fas fa-times"></i>
        </button>
      </div>

      <div class="bg-gray-100 border-bottom d-flex">
        <a
          class="tab-link-item p-3"
          :class="{ 'selected-tab': selectedTab === 'rules' }"
          href="#"
          @click.prevent="selectedTab = 'rules'"
        >
          Regras Aplicáveis
        </a>

        <a
          class="tab-link-item p-3"
          :class="{ 'selected-tab': selectedTab === 'future-rules' }"
          href="#"
          @click.prevent="selectedTab = 'future-rules'"
        >
          Regras Futuras
        </a>

        <a
          class="tab-link-item p-3"
          :class="{ 'selected-tab': selectedTab === 'rules-not-applicable' }"
          href="#"
          @click.prevent="selectedTab = 'rules-not-applicable'"
        >
          Regras Não Aplicáveis
        </a>

        <a
          class="tab-link-item p-3"
          :class="{ 'selected-tab': selectedTab === 'genial-report' }"
          href="#"
          @click.prevent="selectedTab = 'genial-report'"
        >
          Relatório Genial (Indivídual)
        </a>

        <a
          class="tab-link-item p-3"
          :class="{ 'selected-tab': selectedTab === 'genial-report-both' }"
          href="#"
          @click.prevent="selectedTab = 'genial-report-both'"
        >
          Relatório Genial (Ambos)
        </a>
      </div>

      <div class="flex-grow-1 p-3">
        <div v-if="loading" class="text-center text-gray-600 text-default my-4">
          <b-spinner class="align-middle"></b-spinner>
          <strong> Carregando regras ...</strong>
        </div>
        <div v-else class="d-flex h-100">
          <div v-if="selectedTab === 'genial-report-both'" class="w-100 h-100">
            <div class="rules-container">
              <component 
                :is="currentComponent" 
                :calculationId="calculationId"
                :applicableRules="combinedRules.applicableRules"
                :futureRules="combinedRules.futureRules"
                :notApplicableRules="combinedRules.notApplicableRules"
                :loadingRules="loading"
                :workRecords="workRecords"
                :customer="customer"
                :calculation="calculation"
                :regimeDate="regimeDate"
                :regimeType="''"
              />
            </div>
          </div>
          
          <template v-else>
            <div class="w-50 border-right pl-3 pr-3 h-100 rpps-section">
              <h6 class="text-uppercase text-gray-600 mb-3 mt-3">Regras RPPS</h6>
              <div class="rules-container">
                <component 
                  :is="currentComponent" 
                  :calculationId="calculationId"
                  :applicableRules="selectedTab === 'rules' ? rppsRules.applicableRules : []"
                  :futureRules="selectedTab === 'future-rules' ? rppsRules.futureRules : []"
                  :notApplicableRules="selectedTab === 'rules-not-applicable' ? rppsRules.notApplicableRules : []"
                  :loadingRules="loading"
                  :workRecords="workRecords"
                  :customer="customer"
                  :calculation="calculation"
                  :regimeDate="regimeDate"
                  :regimeType="'RPPS'"
                />
              </div>
            </div>

            <div class="w-50 pl-3 h-100 rgps-section">
              <h6 class="text-uppercase text-gray-600 mb-3 mt-3">Regras RGPS</h6>
              <div class="rules-container">
                <component 
                  :is="currentComponent" 
                  :calculationId="calculationId"
                  :applicableRules="selectedTab === 'rules' ? rgpsRules.applicableRules : []"
                  :futureRules="selectedTab === 'future-rules' ? rgpsRules.futureRules : []"
                  :notApplicableRules="selectedTab === 'rules-not-applicable' ? rgpsRules.notApplicableRules : []"
                  :loadingRules="loading"
                  :workRecords="workRecords"
                  :customer="customer"
                  :calculation="calculation"
                  :regimeDate="regimeDate"
                  :regimeType="'RGPS'"
                />
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import Rules from '@/views/customer/Rules.vue';
import FutureRules from '@/views/customer/FutureRules.vue';
import RulesNotApplicable from '@/views/customer/RulesNotApplicable.vue';
import GenialReport from '@/views/customer/GenialReport.vue';
import axios from 'axios';

export default {
  name: 'CompareRulesModal',
  
  components: {
    Rules,
    FutureRules,
    RulesNotApplicable,
    GenialReport
  },

  props: {
    calculationId: {
      type: [String, Number],
      required: true
    },
    workRecords: {
      type: Array,
      required: true
    },
    customer: {
      type: Object,
      required: true
    },
    calculation: {
      type: Object,
      required: true
    },
    regimeDate: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      show: false,
      selectedTab: 'rules',
      loading: false,
      rppsRules: {
        applicableRules: [],
        notApplicableRules: [],
        futureRules: []
      },
      rgpsRules: {
        applicableRules: [],
        notApplicableRules: [],
        futureRules: []
      }
    }
  },

  computed: {
    currentComponent() {
      switch (this.selectedTab) {
        case 'rules':
          return 'Rules';
        case 'future-rules':
          return 'FutureRules';
        case 'rules-not-applicable':
          return 'RulesNotApplicable';
        case 'genial-report':
          return 'GenialReport';
        case 'genial-report-both':
          return 'GenialReport';
        default:
          return 'Rules';
      }
    },
    
    combinedRules() {
      return {
        applicableRules: [...this.rppsRules.applicableRules, ...this.rgpsRules.applicableRules],
        futureRules: [...this.rppsRules.futureRules, ...this.rgpsRules.futureRules],
        notApplicableRules: [...this.rppsRules.notApplicableRules, ...this.rgpsRules.notApplicableRules]
      };
    }
  },

  methods: {
    async open() {
      this.show = true;
      this.loading = true;

      try {
        const rppsResponse = await axios.get(`/calculations/${this.calculationId}/rules`, {
          params: { regimeType: 'RPPS' }
        });
        this.rppsRules = rppsResponse.data;

        const rgpsResponse = await axios.get(`/calculations/${this.calculationId}/rules`, {
          params: { regimeType: 'RGPS' }
        });
        this.rgpsRules = rgpsResponse.data;
      } catch (err) {
        console.error('Error fetching rules:', err);
      } finally {
        this.loading = false;
      }
    },
    close() {
      this.show = false;
      this.rppsRules = {
        applicableRules: [],
        notApplicableRules: [],
        futureRules: []
      };
      this.rgpsRules = {
        applicableRules: [],
        notApplicableRules: [],
        futureRules: []
      };
    }
  }
}
</script>

<style>
.compare-rules-modal .modal-dialog {
  max-width: 100%;
  margin: 0;
}

.compare-rules-modal .modal-content {
  height: 100vh;
  border-radius: 0;
}

.compare-rules-modal .modal-body {
  height: calc(100vh - 120px);
  overflow: hidden;
}

.rules-container {
  height: calc(100vh - 180px);
  overflow-y: auto;
  padding-right: 10px;
}

.tab-link-item {
  color: #6c757d;
  text-decoration: none;
  border-bottom: 2px solid transparent;
}

.tab-link-item:hover {
  color: #495057;
  text-decoration: none;
}

.tab-link-item.selected-tab {
  color: #007bff;
  border-bottom: 2px solid #007bff;
}

.rpps-section {
  background-color: #fff3e0;
}

.rgps-section {
  background-color: #f0f8ff;
}
</style> 